import { Skeleton, SkeletonItem } from "@fluentui/react-components";
import { Col } from "react-grid-system";
import useStyleUtils from "../../utilities/styles";

export default function PlaceholderCard() {
    const style = useStyleUtils();

    return (
        <Col xs={12} md={6} lg={4}>
            <Skeleton>
                <SkeletonItem size={96} className={style.mb3} />
            </Skeleton>
        </Col>
    );
}